(function () {
  function translate(key, fallback) {
    return (window.jerseyBuilderTranslations && window.jerseyBuilderTranslations[key]) || fallback;
  }

  function addWeglotDynamicAttribute(element, attribute, source) {
    if (!element || !attribute || !source) return;

    const current = (element.getAttribute('data-weglot-dynamic-attributes') || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);

    if (!current.includes(attribute)) current.push(attribute);

    element.setAttribute('data-weglot-dynamic-attributes', current.join(','));
    element.setAttribute(`data-weglot-source-${attribute}`, source);
  }

  function markWeglotDynamicText(element, source) {
    if (!element) return;

    if (!source) {
      element.removeAttribute('data-weglot-dynamic');
      element.removeAttribute('data-weglot-source');
      return;
    }

    element.setAttribute('data-weglot-dynamic', 'text');
    element.setAttribute('data-weglot-source', source);
  }

  function notifyDynamicContent(root) {
    if (!root) return;

    root.dispatchEvent(
      new CustomEvent('fk:dynamic-content:rendered', {
        bubbles: true,
        detail: { root }
      })
    );
  }

  const SELECTORS = {
    root: '[data-jersey-builder]',
    data: '[data-jersey-builder-json]',
    productTitle: '[data-jersey-product-title]',
    productSwitches: '[data-jersey-product-switch]',
    productStatus: '[data-jersey-product-status]',
    frame: '.jersey-builder__image-frame',
    image: '[data-jersey-image]',
    placeholder: '[data-jersey-placeholder]',
    namePreview: '[data-preview-name]',
    numberPreview: '[data-preview-number]',
    price: '[data-estimated-price]',
    priceCompare: '.jersey-builder__compare-price',
    memberPriceBadge: '.jersey-builder__member-price-badge',
    garnishOptions: '[data-garnitura-options]',
    sizeOptions: '[data-size-options]',
    sponsorOptions: '[data-sponsor-options]',
    printTypeOptions: '[data-print-type-options]',
    playerWrap: '[data-player-wrap]',
    customWrap: '[data-custom-wrap]',
    playerSelect: '[data-player-select]',
    customName: '[data-custom-name]',
    customNumber: '[data-custom-number]',
    addButton: '[data-add-to-cart]',
    draftOrderButton: '[data-submit-draft-order]',
    draftOrderStatus: '[data-draft-order-status]',
    resetDraftOrderButton: '[data-reset-draft-order]',
    draftOrderModal: '[data-draft-order-modal]',
    draftOrderModalDialog: '[data-draft-order-modal-dialog]',
    draftOrderModalNumber: '[data-draft-order-modal-number]',
    draftOrderModalPrice: '[data-draft-order-modal-price]',
    cartForm: '[data-jersey-cart-form]',
    hiddenVariantId: '[data-hidden-variant-id]',
    hiddenSponsor: '[data-hidden-sponsor]',
    hiddenPrintType: '[data-hidden-print-type]',
    hiddenPlayer: '[data-hidden-player]',
    hiddenCustomName: '[data-hidden-custom-name]',
    hiddenCustomNumber: '[data-hidden-custom-number]',
    hiddenSponsorKey: '[data-hidden-sponsor-key]',
    hiddenSponsorCount: '[data-hidden-sponsor-count]',
    hiddenPrintTypeKey: '[data-hidden-print-type-key]',
    hiddenPlayerName: '[data-hidden-player-name]',
    hiddenPlayerNumber: '[data-hidden-player-number]',
    hiddenPrivateCustomName: '[data-hidden-private-custom-name]',
    hiddenPrivateCustomNumber: '[data-hidden-private-custom-number]',
    hiddenCompareAtPrice: '[data-hidden-compare-at-price]',
    priceSticky: '[data-estimated-price-sticky]',
    stickyBar: '.jersey-builder__sticky-bar',
    stickyAddButton: '[data-sticky-add-to-cart]',
    stickyDraftOrderButton: '[data-sticky-submit-draft-order]',
    stickyPreview: '[data-jersey-sticky-preview]',
    stickyPreviewImage: '[data-sticky-preview-image]',
    stickyPreviewDetails: '[data-sticky-preview-details]',
    stickyPreviewPrint: '[data-sticky-preview-print]',
    stickyPreviewPrice: '[data-sticky-preview-price]'
  };

  const CLASS_NAMES = {
    collapsedStep: 'jersey-builder__step--collapsed',
    emptyStickyImage: 'is-empty',
    hiddenStickyBar: 'is-hidden',
    visibleStickyPreview: 'is-visible',
    optionCard: 'jersey-builder__option--card',
    optionSize: 'jersey-builder__option--size',
    optionSegmented: 'jersey-builder__option--segmented',
    optionImage: 'jersey-builder__option-image',
    selectShell: 'jersey-builder__select-shell',
    select: 'jersey-builder__select jersey-builder__select--large',
    visuallyHidden: 'visually-hidden'
  };

  const FALLBACKS = {
    letterPrice: 3,
    digitPrice: 10,
    sponsorPrice: 5.95
  };

  const OPTION_INDEXES = {
    garnitura: 0,
    size: 1
  };

  const GARNITURA_FALLBACK_TYPES = ['home', 'away', 'third'];
  const GARNITURA_ALIASES = Object.freeze({
    home: ['home', 'domaci'],
    away: ['away', 'gostujuci'],
    third: ['third', 'treci'],
    special: ['special', '80 godina']
  });
  const GARNITURA_TYPES = Object.keys(GARNITURA_ALIASES);
  const NUMBER_STYLE_BY_GARNITURA = Object.freeze({
    home: 'white',
    away: 'maroon',
    third: 'white'
  });
  const JERSEY_PREVIEW_WIDTHS = Object.freeze([800, 1200, 1600]);
  const KIOSK_CACHE_WARMUP_DELAY_MS = 1500;
  const KIOSK_CACHE_WARMUP_IDLE_TIMEOUT_MS = 2000;
  const NUMBER_ASSET_PRELOADS = new Map();

  function getNoSponsorFallback() {
    return { label: translate('no_sponsor', 'Bez sponzora'), value: 'none', price: 0 };
  }

  function getPrintTypes() {
    return [
      { label: translate('print_none', 'Bez printa'), value: 'none' },
      { label: translate('print_player', 'Igrac'), value: 'player' },
      { label: translate('print_custom', 'Custom'), value: 'custom' }
    ];
  }

  let _printTypeLabels = null;
  function getPrintTypeLabels() {
    return _printTypeLabels || (_printTypeLabels = mapBy(getPrintTypes(), 'value', (type) => type.label));
  }

  function normalizeSearchText(value) {
    return String(value || '')
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeKey(value) {
    return normalizeSearchText(value)
      .replace(/jersey/g, '')
      .replace(/dres/g, '')
      .replace(/trikot/g, '')
      .replace(/maglia/g, '')
      .replace(/maglie/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeGarnitura(value) {
    return normalizeKey(value);
  }

  function garnituraType(value, index) {
    const key = normalizeGarnitura(value);
    if (GARNITURA_TYPES.includes(key)) return key;

    const aliasedType = GARNITURA_TYPES.find((type) =>
      GARNITURA_ALIASES[type].some((alias) => key === alias || key.includes(alias))
    );
    if (aliasedType) return aliasedType;

    return GARNITURA_FALLBACK_TYPES[index] || `kit-${index}`;
  }

  function normalizeSponsor(value) {
    return normalizeKey(value) || 'none';
  }

  function unique(values) {
    return Array.from(new Set(values)).filter(Boolean);
  }

  function mapBy(items, key, getValue) {
    return items.reduce((map, item) => {
      map[item[key]] = getValue ? getValue(item) : item;
      return map;
    }, {});
  }

  function priceFrom(value, fallback) {
    const rawValue = value && typeof value === 'object' && 'amount' in value ? value.amount : value;
    if (rawValue === null || rawValue === undefined || rawValue === '') return fallback;

    const number = Number(typeof rawValue === 'string' ? rawValue.trim().replace(',', '.') : rawValue);
    return Number.isFinite(number) ? number : fallback;
  }

  function priceToCents(price) {
    return Math.round(Number(price || 0) * 100);
  }

  function formatMoney(cents, format) {
    const roundedCents = Math.round(cents);

    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(roundedCents, format);
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const moneyFormat = format || 'KM {{amount_with_comma_separator}}';
    const amount = roundedCents / 100;

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) {
        return 0;
      }

      number = number.toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    function formatByPlaceholder(placeholder) {
      switch (placeholder) {
        case 'amount':
          return formatWithDelimiters(amount, 2);
        case 'amount_no_decimals':
          return formatWithDelimiters(amount, 0);
        case 'amount_with_comma_separator':
          return formatWithDelimiters(amount, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return formatWithDelimiters(amount, 0, '.', ',');
        default:
          return formatWithDelimiters(amount, 2);
      }
    }

    const placeholder = moneyFormat.match(placeholderRegex)?.[1];

    if (!placeholder) {
      return moneyFormat;
    }

    return moneyFormat.replace(placeholderRegex, formatByPlaceholder(placeholder));
  }

  function getBuilderDisplayPrice(totalPrice, variant, productTags) {
    const basePrice = Number(variant?.price || 0);
    const baseCompareAtPrice = Number(variant?.compare_at_price || 0);
    const customizationPrice = Math.max(0, Number(totalPrice || 0) - basePrice);
    const saleCompareAtPrice = baseCompareAtPrice > basePrice
      ? baseCompareAtPrice + customizationPrice
      : null;
    const hasMemberPrice = Boolean(window.memberPricing?.isEnabled?.(productTags) && window.memberPricing?.getPrice);

    if (!hasMemberPrice) {
      return {
        price: Number(totalPrice || 0),
        compareAtPrice: saleCompareAtPrice,
        isMemberPrice: false
      };
    }

    const memberBasePrice = window.memberPricing.getPrice(basePrice, baseCompareAtPrice, productTags);

    return {
      price: memberBasePrice.price + customizationPrice,
      compareAtPrice: memberBasePrice.compareAtPrice
        ? memberBasePrice.compareAtPrice + customizationPrice
        : null,
      isMemberPrice: memberBasePrice.isMemberPrice
    };
  }

  function variantImage(variant) {
    return (
      (variant && variant.featured_image && (variant.featured_image.src || variant.featured_image.url)) ||
      (variant && variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) ||
      ''
    );
  }

  function shopifyImageUrl(source, width) {
    if (!source || !width) return source || '';

    try {
      const url = new URL(source, window.location.origin);
      if (!url.pathname.includes('/cdn/shop/')) return source;

      url.searchParams.set('width', String(Math.round(width)));
      return url.toString();
    } catch (_error) {
      return source;
    }
  }

  function shopifyImageSrcset(source, widths) {
    if (!source) return '';

    const candidates = unique(widths)
      .map((width) => Number(width))
      .filter((width) => Number.isFinite(width) && width > 0)
      .map((width) => {
        const url = shopifyImageUrl(source, width);
        return url && url !== source ? `${url} ${width}w` : '';
      })
      .filter(Boolean);

    return candidates.join(', ');
  }

  class KioskImageCacheWarmer {
    constructor(root, model, frame) {
      this.root = root;
      this.models = Array.isArray(model) ? model : [model];
      this.frame = frame;
      this.started = false;
      this.finished = false;
      this.readyToWarm = false;
      this.scheduled = false;
      this.active = 0;
      this.loaded = 0;
      this.failed = 0;
      this.queue = [];
      this.queueIndex = 0;
      this.total = 0;
      this.width = 0;
      this.concurrency = 2;
      this.delay = KIOSK_CACHE_WARMUP_DELAY_MS;
      this.delayTimer = 0;

      this.begin = this.begin.bind(this);
      this.enable = this.enable.bind(this);
      this.pump = this.pump.bind(this);
      this.handleAvailabilityChange = this.handleAvailabilityChange.bind(this);
    }

    start(options = {}) {
      if (!this.root.hasAttribute('data-jersey-kiosk') || this.started) return;

      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection && connection.saveData) {
        this.root.dataset.jerseyCacheWarmup = 'skipped-save-data';
        return;
      }

      this.started = true;
      this.delay = options.delay ?? KIOSK_CACHE_WARMUP_DELAY_MS;
      this.width = this.getPreviewCandidateWidth();
      const sources = this.buildSources();
      this.total = sources.length;
      this.queue = sources.map((source) => ({ source, attempt: 0 }));
      this.concurrency = connection && /(^|-)2g$/.test(connection.effectiveType || '') ? 1 : 2;

      this.root.dataset.jerseyCacheWarmup = 'waiting';
      document.addEventListener('visibilitychange', this.handleAvailabilityChange);
      window.addEventListener('online', this.handleAvailabilityChange);

      if (options.afterPageLoad && document.readyState !== 'complete') {
        window.addEventListener('load', this.begin, { once: true });
      } else {
        this.begin();
      }
    }

    getPreviewCandidateWidth() {
      const frameWidth = this.frame ? this.frame.clientWidth : 0;
      const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
      const targetWidth = Math.min(
        JERSEY_PREVIEW_WIDTHS[JERSEY_PREVIEW_WIDTHS.length - 1],
        Math.max(
          JERSEY_PREVIEW_WIDTHS[0],
          Math.ceil(((frameWidth || 600) * pixelRatio) / 100) * 100
        )
      );

      return (
        JERSEY_PREVIEW_WIDTHS.find((width) => width >= targetWidth) ||
        JERSEY_PREVIEW_WIDTHS[JERSEY_PREVIEW_WIDTHS.length - 1]
      );
    }

    buildSources() {
      const imageSources = unique(this.models.flatMap((model) => [
        ...Object.values(model.imageMap),
        ...model.variants.map(variantImage),
        ...Object.values(model.garnituraImageMap)
      ]))
        .map((source) => shopifyImageUrl(source, this.width))
        .filter(Boolean);
      const numberSources = unique(
        this.models.flatMap((model) => Object.values(model.numberAssets).reduce((sources, styleSources) => {
          if (Array.isArray(styleSources)) sources.push(...styleSources);
          return sources;
        }, []))
      );

      return unique([...imageSources, ...numberSources]);
    }

    begin() {
      this.root.dataset.jerseyCacheWarmup = 'running';
      this.delayTimer = window.setTimeout(this.enable, this.delay);
    }

    enable() {
      this.delayTimer = 0;
      this.readyToWarm = true;
      this.schedule();
    }

    isPaused() {
      return document.visibilityState === 'hidden' || navigator.onLine === false;
    }

    schedule() {
      if (this.finished || !this.readyToWarm || this.scheduled || this.isPaused()) return;
      if (this.queueIndex >= this.queue.length) {
        if (this.active === 0) this.finish();
        return;
      }

      this.scheduled = true;
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(this.pump, { timeout: KIOSK_CACHE_WARMUP_IDLE_TIMEOUT_MS });
      } else {
        window.setTimeout(this.pump, 50);
      }
    }

    pump(deadline) {
      this.scheduled = false;
      if (this.finished || this.isPaused()) return;

      while (this.active < this.concurrency && this.queueIndex < this.queue.length) {
        const hasIdleTime = !deadline || deadline.didTimeout || deadline.timeRemaining() > 4;
        if (!hasIdleTime) break;
        this.load(this.queue[this.queueIndex]);
        this.queueIndex += 1;
      }

      if (this.queueIndex >= this.queue.length && this.active === 0) this.finish();
      else if (this.queueIndex < this.queue.length && this.active < this.concurrency) this.schedule();
    }

    load(item) {
      this.active += 1;
      const image = new Image();
      image.decoding = 'async';
      image.fetchPriority = 'low';
      image.onload = this.handleImageLoad.bind(this, item, image);
      image.onerror = this.settle.bind(this, item, image, false);
      image.src = item.source;

      // Some WebKit versions do not consistently emit load for memory-cached
      // images, so explicitly settle already-complete requests.
      if (image.complete) {
        if (image.naturalWidth > 0) this.handleImageLoad(item, image);
        else this.settle(item, image, false);
      }
    }

    handleImageLoad(item, image) {
      if (typeof image.decode !== 'function') {
        this.settle(item, image, true);
        return;
      }

      const settleLoaded = this.settle.bind(this, item, image, true);
      image.decode().then(settleLoaded, settleLoaded);
    }

    settle(item, image, didLoad) {
      if (!image.onload && !image.onerror) return;

      image.onload = null;
      image.onerror = null;
      this.active -= 1;

      if (didLoad) this.loaded += 1;
      else if (item.attempt === 0) this.queue.push({ source: item.source, attempt: 1 });
      else this.failed += 1;

      this.schedule();
    }

    handleAvailabilityChange() {
      if (!this.isPaused()) this.schedule();
    }

    finish() {
      if (this.finished) return;

      this.finished = true;
      this.cleanup();
      this.root.dataset.jerseyCacheWarmup = this.failed ? 'partial' : 'complete';
      this.root.dispatchEvent(
        new CustomEvent('jersey-builder:cache-warmed', {
          bubbles: true,
          detail: {
            total: this.total,
            loaded: this.loaded,
            failed: this.failed,
            width: this.width
          }
        })
      );
    }

    cleanup() {
      if (this.delayTimer) window.clearTimeout(this.delayTimer);
      window.removeEventListener('load', this.begin);
      window.removeEventListener('online', this.handleAvailabilityChange);
      document.removeEventListener('visibilitychange', this.handleAvailabilityChange);
    }
  }

  function createOptionButton(item, selected, options = {}) {
    const button = document.createElement('button');
    const className = options.className || 'jersey-builder__option';

    button.type = 'button';
    button.className = className;
    button.dataset.value = item.value;
    button.disabled = Boolean(item.disabled);
    button.setAttribute('aria-pressed', item.value === selected ? 'true' : 'false');

    if (item.image) {
      const image = document.createElement('img');
      image.className = CLASS_NAMES.optionImage;
      image.src = shopifyImageUrl(item.image, 160);
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      button.appendChild(image);
    }

    const isCard = className.includes('--card');
    if (isCard || item.image) {
      button.setAttribute('aria-label', item.label);
      addWeglotDynamicAttribute(button, 'aria-label', item.label);
      if (!isCard) button.title = item.label;
      if (!isCard) addWeglotDynamicAttribute(button, 'title', item.label);
    } else {
      button.textContent = item.label;
      markWeglotDynamicText(button, item.label);
    }

    if (item.image && !isCard) {
      const text = document.createElement('span');
      text.className = CLASS_NAMES.visuallyHidden;
      text.textContent = item.label;
      markWeglotDynamicText(text, item.label);
      button.appendChild(text);
    }

    return button;
  }

  function createOption(label, value, selected, options = {}) {
    const option = document.createElement('option');
    option.textContent = label;
    option.value = value;
    option.selected = selected;
    if (options.translate !== false) markWeglotDynamicText(option, label);
    return option;
  }

  function setButtonLabel(button, label) {
    if (!button) return;

    let labelElement = button.querySelector('span');
    if (!labelElement) {
      labelElement = document.createElement('span');
      button.textContent = '';
      button.appendChild(labelElement);
    }

    labelElement.textContent = label;
    markWeglotDynamicText(labelElement, label);
  }

  function setHiddenInput(input, value) {
    if (!input) return;
    input.value = value || '';
    input.disabled = !value;
  }

  function sponsorCount(value, label) {
    if (!value || value === 'none') return 0;

    const source = String(label || value);
    const parts = source
      .split('+')
      .map((part) => part.trim())
      .filter(Boolean);

    return Math.max(1, parts.length);
  }

  function sanitizeName(value) {
    const normalized = value.replace(/[^\p{L}\s]/gu, '').replace(/\s+/g, ' ').toUpperCase();
    let letterCount = 0;
    let result = '';

    for (const character of Array.from(normalized)) {
      if (/\p{L}/u.test(character)) {
        if (letterCount >= 11) break;
        letterCount += 1;
      }
      result += character;
    }

    return result.trim();
  }

  function countLetters(value) {
    return Array.from(String(value || '')).filter((character) => /\p{L}/u.test(character)).length;
  }

  function sanitizeNumber(value) {
    return value.replace(/\D/g, '').slice(0, 2);
  }

  function readBuilderData(root) {
    const script = root.querySelector(SELECTORS.data);
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('Jersey builder data could not be parsed.', error);
      return null;
    }
  }

  function queryElements(root) {
    return Object.keys(SELECTORS).reduce((elements, key) => {
      if (key === 'productSwitches') {
        elements[key] = Array.from(root.querySelectorAll(SELECTORS[key]));
      } else if (key !== 'root' && key !== 'data') {
        elements[key] = root.querySelector(SELECTORS[key]);
      }
      return elements;
    }, {});
  }

  function setSubmissionPending(root, pending) {
    const currentCount = Number(root.dataset.jerseySubmissionCount || 0);
    const nextCount = Math.max(0, currentCount + (pending ? 1 : -1));

    root.dataset.jerseySubmissionCount = String(nextCount);
    root.querySelectorAll(SELECTORS.productSwitches).forEach((button) => {
      button.disabled = nextCount > 0;
    });
  }

  function createBuilderModel(data) {
    const optionNames = data.optionNames || [];
    const garnituraIndex = OPTION_INDEXES.garnitura;
    const sizeIndex = optionNames.length > OPTION_INDEXES.size ? OPTION_INDEXES.size : OPTION_INDEXES.garnitura;

    const garnituraValues = unique((data.variants || []).map((variant) => variant.options && variant.options[garnituraIndex]));
    const garnituraValueMap = garnituraValues.reduce((map, value, index) => {
      const normalized = normalizeGarnitura(value);
      if (normalized) map[normalized] = garnituraType(value, index);
      return map;
    }, {});
    const garnituraLabelMap = garnituraValues.reduce((labels, value, index) => {
      const type = garnituraType(value, index);
      if (type && !labels[type]) labels[type] = value || type;
      return labels;
    }, {});

    const variants = (data.variants || []).map((variant) => ({
      ...variant,
      garnitura: garnituraValueMap[normalizeGarnitura(variant.options && variant.options[garnituraIndex])] || '',
      size: variant.options && variant.options[sizeIndex]
    }));

    const garnituras = unique(variants.map((variant) => variant.garnitura)).sort(
      (left, right) => Number(right === 'special') - Number(left === 'special')
    );
    const imageMapGarnituraValues = unique((data.imageMaps || []).map((item) => item.garnitura));
    const imageMapGarnituraValueMap = imageMapGarnituraValues.reduce((map, value, index) => {
      const normalized = normalizeGarnitura(value);
      if (!normalized) return map;
      map[normalized] = GARNITURA_TYPES.includes(normalized) ? normalized : garnituraValueMap[normalized] || garnituraType(value, index);
      return map;
    }, {});

    const imageMap = (data.imageMaps || []).reduce((images, item) => {
      const garnitura = imageMapGarnituraValueMap[normalizeGarnitura(item.garnitura)] || '';
      const sponsor = normalizeSponsor(item.sponsor);
      if (item.image) images[imageKey(garnitura, sponsor)] = item.image;
      return images;
    }, {});

    const variantMap = variants.reduce((map, variant) => {
      map[variantKey(variant.garnitura, variant.size)] = variant;
      return map;
    }, {});
    const variantIdMap = variants.reduce((map, variant) => {
      map[String(variant.id)] = variant;
      return map;
    }, {});
    const garnituraImageMap = variants.reduce((images, variant) => {
      const image = variantImage(variant);
      if (variant.garnitura && image && !images[variant.garnitura]) images[variant.garnitura] = image;
      return images;
    }, {});

    const sponsors = (data.sponsors || []).length ? data.sponsors : [getNoSponsorFallback()];
    const pricing = {
      letter: priceFrom(data.pricing && data.pricing.letter, FALLBACKS.letterPrice),
      digit: priceFrom(data.pricing && data.pricing.digit, FALLBACKS.digitPrice),
      sponsor: priceFrom(data.pricing && data.pricing.sponsor, FALLBACKS.sponsorPrice)
    };

    const normalizedSponsors = sponsors.map((sponsor) => {
      const value = normalizeSponsor(sponsor.value);
      return {
        ...sponsor,
        value,
        label: value === 'none' ? translate('no_sponsor', 'Bez sponzora') : sponsor.label || sponsor.value || ''
      };
    });

    if (!normalizedSponsors.some((sponsor) => sponsor.value === 'none')) {
      normalizedSponsors.unshift(getNoSponsorFallback());
    }

    normalizedSponsors.sort((left, right) => {
      const leftIsNone = left.value === 'none';
      const rightIsNone = right.value === 'none';
      if (leftIsNone || rightIsNone) return Number(rightIsNone) - Number(leftIsNone);

      const countDifference =
        sponsorCount(left.value, left.label) - sponsorCount(right.value, right.label);
      if (countDifference !== 0) return countDifference;

      return String(left.label).localeCompare(String(right.label), undefined, {
        sensitivity: 'base',
        numeric: true
      });
    });

    const sponsorPriceMap = normalizedSponsors.reduce((prices, sponsor) => {
      prices[sponsor.value] = priceFrom(sponsor.price, sponsor.value === 'none' ? 0 : pricing.sponsor);
      return prices;
    }, {});

    const players = [...(data.players || [])].sort((left, right) => {
      const leftNumber = Number(left.number);
      const rightNumber = Number(right.number);
      const leftHasNumber = Number.isFinite(leftNumber) && String(left.number).trim() !== '';
      const rightHasNumber = Number.isFinite(rightNumber) && String(right.number).trim() !== '';

      if (leftHasNumber !== rightHasNumber) return leftHasNumber ? -1 : 1;
      if (leftHasNumber && leftNumber !== rightNumber) return leftNumber - rightNumber;

      return String(left.name || '').localeCompare(String(right.name || ''), undefined, {
        sensitivity: 'base',
        numeric: true
      });
    });

    return {
      productKey: String(data.key || data.id || ''),
      productId: data.id,
      productTags: data.tags || [],
      productTitle: data.title || '',
      productLabel: data.label || data.title || '',
      fontKey: data.fontKey || 'current_23_24',
      fontFamily: data.fontFamily || 'FK Sarajevo 23-24',
      fontWeight: Number(data.fontWeight || 700),
      garnituras,
      sizes: unique(variants.map((variant) => variant.size)),
      sponsors: normalizedSponsors,
      players,
      pricing,
      numberAssets: data.numberAssets || {},
      imageMap,
      garnituraLabelMap,
      sponsorLabelMap: mapBy(normalizedSponsors, 'value', (sponsor) => sponsor.label),
      sponsorPriceMap,
      variantMap,
      variantIdMap,
      variants,
      garnituraImageMap,
      initialVariantId: data.initialVariantId,
      moneyFormat: data.moneyFormat
    };
  }

  function variantKey(garnitura, size) {
    return `${garnitura}:${normalizeKey(size)}`;
  }

  function imageKey(garnitura, sponsor) {
    return `${garnitura}:${sponsor}`;
  }

  function isFrontImage(source) {
    if (!source) return false;

    try {
      const pathname = new URL(String(source), window.location.origin).pathname;
      const filename = decodeURIComponent(pathname.split('/').pop() || '');
      return /-front(?:\.[^.]+)?$/i.test(filename);
    } catch (_error) {
      return /-front(?:\.[a-z0-9]+)?(?:\?|$)/i.test(String(source));
    }
  }

  function createBuilderState(model) {
    const initialVariant =
      model.variantIdMap[String(model.initialVariantId)] ||
      model.variants.find((variant) => variant.available) ||
      model.variants[0];

    return {
      garnitura: initialVariant?.garnitura || model.garnituras[0] || 'home',
      size: initialVariant?.size || model.sizes[0] || '',
      sponsor: 'none',
      printType: 'none',
      playerIndex: '',
      customName: '',
      customNumber: ''
    };
  }

  function createProductController(data) {
    const rawProducts = Array.isArray(data.products) && data.products.length
      ? data.products
      : [{ ...data, key: data.initialProductKey || 'legacy' }];
    const sessions = new Map();

    rawProducts.forEach((productData) => {
      const model = createBuilderModel({
        ...productData,
        moneyFormat: productData.moneyFormat || data.moneyFormat,
        numberAssets: productData.numberAssets || data.numberAssets
      });

      if (!model.productKey || sessions.has(model.productKey)) return;
      sessions.set(model.productKey, {
        model,
        state: createBuilderState(model)
      });
    });

    const initialKey = sessions.has(String(data.initialProductKey))
      ? String(data.initialProductKey)
      : sessions.keys().next().value;
    let activeKey = initialKey;

    const model = new Proxy({}, {
      get(_target, property) {
        return sessions.get(activeKey)?.model[property];
      }
    });
    const state = new Proxy({}, {
      get(_target, property) {
        return sessions.get(activeKey)?.state[property];
      },
      set(_target, property, value) {
        const activeState = sessions.get(activeKey)?.state;
        if (!activeState) return false;
        activeState[property] = value;
        return true;
      }
    });

    return {
      model,
      state,
      models: Array.from(sessions.values(), (session) => session.model),
      hasProducts: sessions.size > 0,
      activate(key) {
        const nextKey = String(key || '');
        if (!sessions.has(nextKey)) return false;
        activeKey = nextKey;
        return true;
      },
      activeKey() {
        return activeKey;
      }
    };
  }

  function createSelectors(model, state) {
    function selectedVariant() {
      return model.variantMap[variantKey(state.garnitura, state.size)] || null;
    }

    function selectedPlayer() {
      if (state.playerIndex === '') return null;
      return model.players[Number(state.playerIndex)] || null;
    }

    function printValues() {
      if (state.printType === 'player') {
        const player = selectedPlayer();
        return { name: player ? player.name : '', number: player ? String(player.number) : '' };
      }

      if (state.printType === 'custom') {
        return { name: state.customName, number: state.customNumber };
      }

      return { name: '', number: '' };
    }

    function sponsorLabel() {
      return model.sponsorLabelMap[state.sponsor] || state.sponsor;
    }

    function garnituraImage(garnitura) {
      return model.garnituraImageMap[garnitura] || model.imageMap[imageKey(garnitura, 'none')] || '';
    }

    function displayImageFor(garnitura) {
      const hasSponsor = state.sponsor && state.sponsor !== 'none';
      const hasPrint = state.printType && state.printType !== 'none';

      if (!hasSponsor && !hasPrint) {
        const variant = model.variantMap[variantKey(garnitura, state.size)] || null;
        return variantImage(variant) || garnituraImage(garnitura) || '';
      }

      return (
        model.imageMap[imageKey(garnitura, state.sponsor)] ||
        model.imageMap[imageKey(garnitura, 'none')] ||
        garnituraImage(garnitura) ||
        ''
      );
    }

    function displayImage() {
      return displayImageFor(state.garnitura);
    }

    function totalPrice() {
      const variant = selectedVariant();
      const print = printValues();
      // Shopify variant prices are in cents (e.g. 5000 = 50.00 KM). pricing.letter,
      // pricing.digit, and pricing.sponsor are decimal KM (e.g. 3 = 3.00 KM).
      // Convert each configured unit price to whole cents before calculating the
      // total so the builder uses the same precision as the Shopify cart.
      const base = variant ? Number(variant.price) : 0;
      const printCost =
        countLetters(print.name) * priceToCents(model.pricing.letter) +
        print.number.length * priceToCents(model.pricing.digit);
      const sponsorPrice = model.sponsorPriceMap[state.sponsor] ?? model.pricing.sponsor;
      const sponsorCost = state.sponsor !== 'none' ? priceToCents(sponsorPrice) : 0;

      return base + printCost + sponsorCost;
    }

    return {
      selectedVariant,
      selectedPlayer,
      printValues,
      sponsorLabel,
      garnituraImage,
      displayImageFor,
      displayImage,
      totalPrice
    };
  }

  function createRenderer(root, elements, model, state, selectors) {
    const mobileMedia = window.matchMedia ? window.matchMedia('(max-width: 719px)') : null;
    const previewNameScale = root.hasAttribute('data-jersey-kiosk') ? 0.525 : 1;
    const previewNumberScale = root.hasAttribute('data-jersey-kiosk') ? 0.85 : 1;
    let frameWidth = elements.frame ? elements.frame.clientWidth : 0;
    let requestedPreviewSource = '';
    let isMainPreviewVisible = true;
    let preloadRequestId = 0;
    const preloadedImages = new Map();

    function selectedNumberStyle() {
      return NUMBER_STYLE_BY_GARNITURA[state.garnitura] || 'white';
    }

    function selectedNumberAssets() {
      if (root.dataset.jerseyFont === 'season_26_27') {
        return [];
      }

      const style = selectedNumberStyle();
      return model.numberAssets[style] || model.numberAssets.white || [];
    }

    function isMobile() {
      return mobileMedia ? mobileMedia.matches : window.innerWidth < 720;
    }

    function previewWidth() {
      const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
      return Math.min(
        1600,
        Math.max(800, Math.ceil(((frameWidth || 600) * pixelRatio) / 100) * 100)
      );
    }

    function previewCandidateWidth() {
      const targetWidth = previewWidth();
      return (
        JERSEY_PREVIEW_WIDTHS.find((width) => width >= targetWidth) ||
        JERSEY_PREVIEW_WIDTHS[JERSEY_PREVIEW_WIDTHS.length - 1]
      );
    }

    function preloadSelectedSponsorImages(options = {}) {
      const requestId = ++preloadRequestId;

      function preload() {
        if (requestId !== preloadRequestId) return;

        const width = previewCandidateWidth();
        const sources = unique(model.garnituras.map((garnitura) => selectors.displayImageFor(garnitura)))
          .map((source) => shopifyImageUrl(source, width))
          .filter(Boolean);
        const selectedSources = new Set(sources);

        preloadedImages.forEach((_image, source) => {
          if (!selectedSources.has(source)) preloadedImages.delete(source);
        });

        sources
          .filter((source) => !preloadedImages.has(source))
          .forEach((source) => {
            const image = new Image();
            image.decoding = 'async';
            image.fetchPriority = 'low';
            image.onload = () => {
              image.onload = null;
              image.onerror = null;
            };
            image.onerror = () => {
              preloadedImages.delete(source);
              image.onload = null;
              image.onerror = null;
            };
            preloadedImages.set(source, image);
            image.src = source;
            if (typeof image.decode === 'function') image.decode().catch(() => {});
          });
      }

      function schedule() {
        if (requestId !== preloadRequestId) return;

        if (options.immediate) {
          window.setTimeout(preload, 0);
        } else if ('requestIdleCallback' in window) {
          window.requestIdleCallback(preload, { timeout: 1500 });
        } else {
          window.setTimeout(preload, 500);
        }
      }

      if (options.afterPageLoad && document.readyState !== 'complete') {
        window.addEventListener('load', schedule, { once: true });
      } else {
        schedule();
      }
    }

    function preloadNumberAssets(options = {}) {
      const sources = selectedNumberAssets().filter(Boolean);

      function preload() {
        sources.forEach((source) => {
          if (NUMBER_ASSET_PRELOADS.has(source)) return;

          const image = new Image();
          image.decoding = 'async';
          image.fetchPriority = options.immediate ? 'high' : 'low';
          image.onload = () => {
            image.onload = null;
            image.onerror = null;
          };
          image.onerror = () => {
            NUMBER_ASSET_PRELOADS.delete(source);
            image.onload = null;
            image.onerror = null;
          };
          NUMBER_ASSET_PRELOADS.set(source, image);
          image.src = source;
          if (typeof image.decode === 'function') image.decode().catch(() => {});
        });
      }

      if (options.afterPageLoad && document.readyState !== 'complete') {
        window.addEventListener('load', preload, { once: true });
      } else if (options.immediate) {
        preload();
      } else if ('requestIdleCallback' in window) {
        window.requestIdleCallback(preload, { timeout: 1500 });
      } else {
        window.setTimeout(preload, 500);
      }
    }

    function renderOptions(container, items, selected, onClick, options = {}) {
      if (!container) return;

      container.innerHTML = '';
      items.forEach((item) => {
        const button = createOptionButton(item, selected, options);
        button.addEventListener('click', () => onClick(item.value));
        container.appendChild(button);
      });
      notifyDynamicContent(container);
    }

    function renderGarnituraOptions(onChange) {
      renderOptions(
        elements.garnishOptions,
        model.garnituras.map((value) => ({
          label: model.garnituraLabelMap[value] || value,
          value,
          image: selectors.garnituraImage(value)
        })),
        state.garnitura,
        onChange,
        { className: CLASS_NAMES.optionCard }
      );
    }

    function renderSizeOptions(onChange) {
      renderOptions(
        elements.sizeOptions,
        model.sizes.map((value) => ({ label: value, value })),
        state.size,
        onChange,
        { className: CLASS_NAMES.optionSize }
      );
    }

    function renderSponsorOptions(onChange) {
      if (!elements.sponsorOptions) return;

      elements.sponsorOptions.replaceChildren();
      const shell = document.createElement('div');
      const select = document.createElement('select');
      shell.className = CLASS_NAMES.selectShell;
      select.className = CLASS_NAMES.select;
      select.setAttribute('aria-label', 'Sponsor');

      model.sponsors.forEach((sponsor) => {
        select.appendChild(createOption(sponsor.label || sponsor.value || 'Sponsor', sponsor.value, sponsor.value === state.sponsor));
      });

      select.addEventListener('change', (event) => onChange(event.target.value));
      shell.appendChild(select);
      elements.sponsorOptions.classList.add('jersey-builder__options--select');
      elements.sponsorOptions.appendChild(shell);
    }

    function renderPrintTypeOptions(onChange) {
      renderOptions(elements.printTypeOptions, getPrintTypes(), state.printType, onChange, {
        className: CLASS_NAMES.optionSegmented
      });
      updatePrintTypeIndicator();
    }

    function renderPlayerOptions() {
      if (!elements.playerSelect) return;

      Array.from(elements.playerSelect.options).slice(1).forEach((option) => option.remove());
      model.players.forEach((player, index) => {
        elements.playerSelect.appendChild(createOption(`${player.name} ${player.number}`, String(index), false, { translate: false }));
      });
      elements.playerSelect.value = state.playerIndex;
    }

    function updatePrintTypeIndicator() {
      if (!elements.printTypeOptions) return;

      const index = Math.max(0, getPrintTypes().findIndex((item) => item.value === state.printType));
      elements.printTypeOptions.style.setProperty('--print-control-offset', `${index * 100}%`);
    }

    function renderImage() {
      const source = selectors.displayImage();
      const targetWidth = previewWidth();
      const image = shopifyImageUrl(source, targetWidth);

      if (!elements.image) return;

      if (!image) {
        requestedPreviewSource = '';
        elements.image.removeAttribute('src');
        elements.image.removeAttribute('srcset');
        elements.image.removeAttribute('sizes');
        elements.image.hidden = true;
        if (elements.placeholder) elements.placeholder.hidden = false;
        return;
      }

      const slotWidth = `${Math.max(1, Math.ceil(frameWidth || 600))}px`;
      if (elements.image.sizes !== slotWidth) elements.image.sizes = slotWidth;

      if (requestedPreviewSource !== source) {
        requestedPreviewSource = source;
        const srcset = shopifyImageSrcset(source, JERSEY_PREVIEW_WIDTHS);
        if (srcset) {
          elements.image.srcset = srcset;
        } else {
          elements.image.removeAttribute('srcset');
        }
        elements.image.src = image;
      }

      elements.image.hidden = false;
      if (elements.placeholder) elements.placeholder.hidden = Boolean(image);
    }

    function renderPreview() {
      const print = selectors.printValues();
      const colorFontNameScale = root.dataset.jerseyFont === 'season_26_27' ? 1.15 : 1;
      const colorFontNumberScale = root.dataset.jerseyFont === 'season_26_27' ? 1.3 : 1;
      const nameLength = Math.max(print.name.length, 1);
      const nameFitSize = (frameWidth * 0.56) / (nameLength * 0.62);
      const baseNameFontSize = Math.max(16, Math.min(38, frameWidth * 0.05, nameFitSize));
      const nameFontSize = baseNameFontSize * 2 * previewNameScale * colorFontNameScale;
      const numberFontSize =
        Math.max(42, Math.min(177, frameWidth * 0.3, baseNameFontSize * 4.9)) *
        1.15 *
        previewNumberScale *
        colorFontNumberScale;

      if (elements.namePreview) {
        elements.namePreview.textContent = print.name.toUpperCase();
        elements.namePreview.style.fontSize = nameFontSize + 'px';
      }

      if (elements.numberPreview) {
        const number = String(print.number || '');
        const usesColorFontNumbers = root.dataset.jerseyFont === 'season_26_27';

        if (usesColorFontNumbers) {
          elements.numberPreview.textContent = number;
        } else {
          const numberAssets = selectedNumberAssets();
          const fragment = document.createDocumentFragment();

          Array.from(number).forEach((digit) => {
            const source = numberAssets[Number(digit)];

            if (!/^\d$/.test(digit) || !source) {
              const fallback = document.createElement('span');
              fallback.className = 'jersey-builder__preview-digit-fallback';
              fallback.textContent = digit;
              fragment.appendChild(fallback);
              return;
            }

            const image = document.createElement('img');
            image.className = 'jersey-builder__preview-digit';
            image.src = source;
            image.alt = '';
            image.decoding = 'async';
            image.fetchPriority = 'high';
            image.draggable = false;
            image.addEventListener('error', () => {
              const fallback = document.createElement('span');
              fallback.className = 'jersey-builder__preview-digit-fallback';
              fallback.textContent = digit;
              image.replaceWith(fallback);
            }, { once: true });
            fragment.appendChild(image);
          });

          elements.numberPreview.replaceChildren(fragment);
        }
        elements.numberPreview.dataset.digitCount = String(number.length);
        elements.numberPreview.dataset.numberStyle = selectedNumberStyle();
        elements.numberPreview.style.height = numberFontSize + 'px';
        elements.numberPreview.style.fontSize = numberFontSize + 'px';
      }
    }

    function renderPrice() {
      const totalPrice = selectors.totalPrice();
      const variant = selectors.selectedVariant();
      const displayPrice = getBuilderDisplayPrice(totalPrice, variant, model.productTags);
      const formattedPrice = formatMoney(displayPrice.price, model.moneyFormat);
      const formattedComparePrice = displayPrice.compareAtPrice ? formatMoney(displayPrice.compareAtPrice, model.moneyFormat) : '';

      [elements.price, elements.priceSticky, elements.stickyPreviewPrice].forEach((element) => {
        if (element) element.textContent = formattedPrice;
      });

      if (elements.priceCompare) {
        elements.priceCompare.textContent = formattedComparePrice;
        elements.priceCompare.hidden = !displayPrice.compareAtPrice;
      }

      if (elements.memberPriceBadge) {
        elements.memberPriceBadge.hidden = !displayPrice.isMemberPrice;
      }
    }

    function renderButtons() {
      const variant = selectors.selectedVariant();
      const isAvailable = Boolean(variant && variant.available);
      const cartLabel = !isAvailable
        ? translate('sold_out', 'Rasprodano')
        : variant.preorder
          ? translate('preorder', 'Prednarudžba')
          : translate('add_to_cart', 'Dodaj u korpu');

      [elements.addButton, elements.stickyAddButton].forEach((button) => {
        if (!button) return;
        button.disabled = !isAvailable;
        setButtonLabel(button, cartLabel);
      });

      [elements.draftOrderButton, elements.stickyDraftOrderButton].forEach((button) => {
        if (!button) return;
        button.disabled = !isAvailable;
        setButtonLabel(
          button,
          isAvailable ? translate('send_to_staff', 'Pošalji osoblju') : translate('sold_out', 'Rasprodano')
        );
      });
    }

    function renderPrintVisibility() {
      const showPlayer = state.printType === 'player';
      const showCustom = state.printType === 'custom';

      if (elements.playerWrap) elements.playerWrap.classList.toggle(CLASS_NAMES.collapsedStep, !showPlayer);
      if (elements.customWrap) elements.customWrap.classList.toggle(CLASS_NAMES.collapsedStep, !showCustom);
      if (elements.playerSelect) elements.playerSelect.disabled = !showPlayer;
      if (elements.customName) elements.customName.disabled = !showCustom;
      if (elements.customNumber) elements.customNumber.disabled = !showCustom;
    }

    function renderSizeAvailability() {
      if (!elements.sizeOptions) return;

      Array.from(elements.sizeOptions.children).forEach((child) => {
        const variant = model.variantMap[variantKey(state.garnitura, child.dataset.value)];
        child.disabled = !variant || !variant.available;
      });
    }

    function renderStickyPreview() {
      if (!elements.stickyPreview) return;

      const image = selectors.displayImage();
      const details = [state.size, state.sponsor !== 'none' ? selectors.sponsorLabel() : ''].filter(Boolean).join(' / ');
      const print = selectors.printValues();
      const printValue = [print.name, print.number].filter(Boolean).join(' ');

      if (elements.stickyPreviewImage) {
        if (image) {
          elements.stickyPreviewImage.src = shopifyImageUrl(image, 180);
        } else {
          elements.stickyPreviewImage.removeAttribute('src');
        }
        elements.stickyPreviewImage.classList.toggle(CLASS_NAMES.emptyStickyImage, !image);
      }
      if (elements.stickyPreviewDetails) elements.stickyPreviewDetails.textContent = details;
      if (elements.stickyPreviewDetails) markWeglotDynamicText(elements.stickyPreviewDetails, details);
      if (elements.stickyPreviewPrint) {
        elements.stickyPreviewPrint.textContent = printValue;
        elements.stickyPreviewPrint.hidden = !printValue;
      }

      updateStickyPreviewVisibility();
    }

    function getHeaderBottom() {
      const header = document.querySelector('#shopify-section-header');
      return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    }

    function isViewportYWithinBuilder(y) {
      const rect = root.getBoundingClientRect();
      return rect.top <= y && rect.bottom > y;
    }

    function updateStickyPreviewOffset() {
      if (!elements.stickyPreview || !isMobile()) return;
      elements.stickyPreview.style.setProperty('--sticky-preview-top', getHeaderBottom() + 'px');
    }

    function updateStickyPreviewVisibility() {
      if (!elements.stickyPreview) return;

      const show = isMobile() && isViewportYWithinBuilder(getHeaderBottom()) && !isMainPreviewVisible;
      updateStickyPreviewOffset();
      elements.stickyPreview.classList.toggle(CLASS_NAMES.visibleStickyPreview, show);
      elements.stickyPreview.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function updateStickyBarVisibility() {
      if (!elements.stickyBar) return;

      const show = isMobile() && isViewportYWithinBuilder(window.innerHeight);
      elements.stickyBar.classList.toggle(CLASS_NAMES.hiddenStickyBar, !show);
      elements.stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function updateStickyVisibility() {
      updateStickyPreviewOffset();
      updateStickyPreviewVisibility();
      updateStickyBarVisibility();
    }

    function updateFrameWidth(width) {
      const previousPreviewWidth = previewWidth();
      frameWidth = width;
      renderPreview();
      if (previewWidth() !== previousPreviewWidth) renderImage();
    }

    function updateRootState() {
      const sponsorLabel = selectors.sponsorLabel();
      const hasStandaloneRGol = sponsorLabel
        .split('+')
        .some((label) => normalizeSponsor(label) === 'r-gol');
      const showsFrontImage = isFrontImage(selectors.displayImage());

      root.dataset.garnitura = state.garnitura;
      root.dataset.garnituraType = state.garnitura;
      root.dataset.sponsor = state.sponsor;
      root.dataset.sponsorLabel = normalizeSponsor(sponsorLabel);
      root.dataset.jerseyView = showsFrontImage ? 'front' : 'back';
      root.classList.toggle(
        'jersey-builder--hide-print-preview',
        hasStandaloneRGol || showsFrontImage
      );
    }

    function setMainPreviewVisible(isVisible) {
      isMainPreviewVisible = isVisible;
      updateStickyPreviewVisibility();
    }

    function renderAll(syncCartForm) {
      updateRootState();
      renderImage();
      renderPreview();
      renderPrice();
      renderButtons();
      renderPrintVisibility();
      renderSizeAvailability();
      renderStickyPreview();
      syncCartForm();
      notifyDynamicContent(root);
    }

    return {
      mobileMedia,
      renderAll,
      renderButtons,
      renderGarnituraOptions,
      renderImage,
      preloadNumberAssets,
      preloadSelectedSponsorImages,
      renderPlayerOptions,
      renderPreview,
      renderPrice,
      renderPrintTypeOptions,
      renderPrintVisibility,
      renderSizeAvailability,
      renderSizeOptions,
      renderSponsorOptions,
      renderStickyPreview,
      setMainPreviewVisible,
      updateRootState,
      updateFrameWidth,
      updateStickyBarVisibility,
      updateStickyVisibility
    };
  }

  function createCartFormSync(elements, state, selectors) {
    return function syncCartForm() {
      const variant = selectors.selectedVariant();
      const print = selectors.printValues();
      const player = selectors.selectedPlayer();
      const playerValue = state.printType === 'player' && player ? `${player.name} ${player.number}` : '';
      const playerName = state.printType === 'player' && player ? player.name : '';
      const playerNumber = state.printType === 'player' && player ? String(player.number || '') : '';
      const customName = state.printType === 'custom' ? print.name : '';
      const customNumber = state.printType === 'custom' ? print.number : '';
      const printTypeLabels = getPrintTypeLabels();
      const printTypeLabel = state.printType !== 'none' ? printTypeLabels[state.printType] || state.printType : '';
      const sponsorLabel = state.sponsor !== 'none' ? selectors.sponsorLabel() : '';
      const privateSponsorKey = state.sponsor || 'none';
      const privateSponsorCount = sponsorCount(state.sponsor, sponsorLabel);
      const totalPrice = selectors.totalPrice();
      const compareAtPrice = variant?.compare_at_price && variant.compare_at_price > variant.price
        ? totalPrice - Number(variant.price) + Number(variant.compare_at_price)
        : totalPrice;

      if (elements.hiddenVariantId) elements.hiddenVariantId.value = variant ? variant.id : '';
      setHiddenInput(elements.hiddenSponsor, sponsorLabel);
      setHiddenInput(elements.hiddenPrintType, printTypeLabel);
      setHiddenInput(elements.hiddenPlayer, playerValue);
      setHiddenInput(elements.hiddenCustomName, customName);
      setHiddenInput(elements.hiddenCustomNumber, customNumber);
      setHiddenInput(elements.hiddenSponsorKey, privateSponsorKey);
      setHiddenInput(elements.hiddenSponsorCount, String(privateSponsorCount));
      setHiddenInput(elements.hiddenPrintTypeKey, state.printType || 'none');
      setHiddenInput(elements.hiddenPlayerName, playerName);
      setHiddenInput(elements.hiddenPlayerNumber, playerNumber);
      setHiddenInput(elements.hiddenPrivateCustomName, customName);
      setHiddenInput(elements.hiddenPrivateCustomNumber, customNumber);
      setHiddenInput(elements.hiddenCompareAtPrice, String(Math.round(compareAtPrice)));
    };
  }

  function createCartSubmitter(root, elements, state, selectors, syncCartForm) {
    let isSubmitting = false;

    return function submit(button) {
      if (isSubmitting) return;
      if (!state.size) return;

      const variant = selectors.selectedVariant();
      if (!variant || !variant.available || !elements.cartForm) return;

      syncCartForm();
      isSubmitting = true;
      setSubmissionPending(root, true);
      button.setAttribute('aria-disabled', 'true');

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        credentials: 'include',
        headers: { Accept: 'application/json' },
        body: new FormData(elements.cartForm)
      })
        .then((response) => {
          if (!response.ok) return response.json().then((payload) => Promise.reject(payload));
          return response.json();
        })
        .then((product) => {
          if (window.goCart && typeof window.goCart.addItemToCartHandler === 'function') {
            window.goCart.addItemToCartHandler(product);
            return;
          }

          document.querySelector('.js-go-cart-trigger')?.dispatchEvent(new Event('click', { bubbles: true }));
        })
        .catch((error) => {
          if (window.goCart && typeof window.goCart.ajaxRequestFail === 'function') {
            window.goCart.ajaxRequestFail();
            return;
          }

          button.removeAttribute('aria-disabled');
          root.dispatchEvent(new CustomEvent('jersey-builder:cart-error', { bubbles: true, detail: { error } }));
        })
        .finally(() => {
          isSubmitting = false;
          setSubmissionPending(root, false);
          button.removeAttribute('aria-disabled');
        });
    };
  }

  function createDraftOrderSubmitter(root, elements, data, state, selectors) {
    const buttons = [elements.draftOrderButton, elements.stickyDraftOrderButton].filter(Boolean);
    const isKiosk = document.body.classList.contains('jersey-kiosk');
    const sectionId = root.querySelector('[data-section-id]')?.dataset.sectionId || 'default';
    const requestTimeoutMs = 20000;
    let isSubmitting = false;
    let completedFingerprint = '';
    let modalTrigger = null;

    function storageKey() {
      return `fk-jersey-draft-order:${sectionId}:${root.dataset.activeProductKey || 'legacy'}`;
    }

    function createRequestId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }

      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }

    function buildPayload() {
      const variant = selectors.selectedVariant();
      const player = selectors.selectedPlayer();
      const print = selectors.printValues();
      const sponsorLabel = state.sponsor !== 'none' ? selectors.sponsorLabel() : '';

      return {
        variantId: variant ? String(variant.id) : '',
        sponsorLabel,
        sponsorKey: state.sponsor || 'none',
        sponsorCount: sponsorCount(state.sponsor, sponsorLabel),
        printType: state.printType || 'none',
        playerName: state.printType === 'player' && player ? String(player.name || '') : '',
        playerNumber: state.printType === 'player' && player ? String(player.number || '') : '',
        customName: state.printType === 'custom' ? print.name : '',
        customNumber: state.printType === 'custom' ? print.number : ''
      };
    }

    function fingerprint(payload) {
      return JSON.stringify(payload);
    }

    function readPendingSubmission(currentFingerprint) {
      try {
        const pending = JSON.parse(window.sessionStorage.getItem(storageKey()) || 'null');
        const isFresh = pending && Date.now() - Number(pending.createdAt || 0) < 24 * 60 * 60 * 1000;
        return isFresh && pending.fingerprint === currentFingerprint ? pending : null;
      } catch (error) {
        return null;
      }
    }

    function savePendingSubmission(submission) {
      try {
        window.sessionStorage.setItem(storageKey(), JSON.stringify(submission));
      } catch (error) {
        // Submission still works when storage is unavailable.
      }
    }

    function clearPendingSubmission() {
      try {
        window.sessionStorage.removeItem(storageKey());
      } catch (error) {
        // No action is required when storage is unavailable.
      }
    }

    function setStatus(message, type) {
      if (!elements.draftOrderStatus) return;
      elements.draftOrderStatus.textContent = message || '';
      elements.draftOrderStatus.hidden = !message;
      elements.draftOrderStatus.classList.toggle('is-error', type === 'error');
      elements.draftOrderStatus.classList.toggle('is-success', type === 'success');
    }

    function setButtons(options = {}) {
      const variant = selectors.selectedVariant();
      const isAvailable = Boolean(variant && variant.available);
      const disabled = options.disabled === true || !isAvailable;
      const label = options.label || (
        isAvailable ? translate('send_to_staff', 'Pošalji osoblju') : translate('sold_out', 'Rasprodano')
      );

      buttons.forEach((button) => {
        button.disabled = disabled;
        button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        setButtonLabel(button, label);
      });
    }

    function validate(payload) {
      if (!/^\d+$/.test(payload.variantId)) return translate('error_unavailable', 'Odabrana kombinacija nije dostupna.');
      if (payload.printType === 'player' && (!payload.playerName || !payload.playerNumber)) {
        return translate('error_select_player', 'Odaberite igrača.');
      }
      if (payload.printType === 'custom' && !payload.customName) {
        return translate('error_custom_name', 'Unesite ime za print.');
      }
      if (payload.printType === 'custom' && !/^\d{1,2}$/.test(payload.customNumber)) {
        return translate('error_custom_number', 'Unesite broj od jedne ili dvije cifre.');
      }
      return '';
    }

    function getSuccessDetails(result) {
      const draft = result && result.draftOrder;
      const reference = draft && draft.name ? String(draft.name).replace(/^#/, '') : '';
      const money = draft && draft.totalPriceSet && draft.totalPriceSet.shopMoney;
      const currency = money && money.currencyCode === 'BAM' ? 'KM' : money && money.currencyCode;
      const total = money && money.amount && currency ? `${money.amount} ${currency}` : '';
      return { reference, total };
    }

    function closeSuccessModal() {
      if (!elements.draftOrderModal || elements.draftOrderModal.hidden) return;

      elements.draftOrderModal.classList.remove('is-open');
      elements.draftOrderModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('jersey-builder-modal-open');

      window.setTimeout(() => {
        elements.draftOrderModal.hidden = true;
        if (isKiosk) {
          startAnother();
          return;
        }
        if (modalTrigger && typeof modalTrigger.focus === 'function') modalTrigger.focus();
      }, 180);
    }

    function trapModalFocus(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeSuccessModal();
        return;
      }

      if (event.key !== 'Tab' || !elements.draftOrderModalDialog) return;
      const focusable = Array.from(
        elements.draftOrderModalDialog.querySelectorAll('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      ).filter((element) => !element.hidden);
      if (!focusable.length) {
        event.preventDefault();
        elements.draftOrderModalDialog.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function openSuccessModal(result) {
      if (!elements.draftOrderModal) return;

      const details = getSuccessDetails(result);
      if (elements.draftOrderModalNumber) elements.draftOrderModalNumber.textContent = details.reference;
      if (elements.draftOrderModalPrice) elements.draftOrderModalPrice.textContent = details.total;

      modalTrigger = document.activeElement;
      elements.draftOrderModal.hidden = false;
      elements.draftOrderModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('jersey-builder-modal-open');
      window.requestAnimationFrame(() => {
        elements.draftOrderModal.classList.add('is-open');
        elements.draftOrderModalDialog?.focus();
      });
    }

    if (elements.draftOrderModal) {
      elements.draftOrderModal.addEventListener('click', (event) => {
        if (event.target.closest('[data-draft-order-modal-close]')) closeSuccessModal();
      });
      elements.draftOrderModal.addEventListener('keydown', trapModalFocus);
    }

    async function submit() {
      if (isSubmitting || !data.draftOrders || !data.draftOrders.enabled || completedFingerprint) return;

      const payload = buildPayload();
      const validationError = validate(payload);
      if (validationError) {
        setStatus(validationError, 'error');
        return;
      }

      const currentFingerprint = fingerprint(payload);
      const pending = readPendingSubmission(currentFingerprint);
      const requestId = pending ? pending.requestId : createRequestId();
      savePendingSubmission({
        requestId,
        fingerprint: currentFingerprint,
        createdAt: pending ? pending.createdAt : Date.now()
      });

      isSubmitting = true;
      setSubmissionPending(root, true);
      setStatus('', '');
      setButtons({ disabled: true, label: translate('sending_to_staff', 'Šaljem...') });

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), requestTimeoutMs);

      try {
        const response = await fetch(data.draftOrders.endpoint, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ ...payload, requestId }),
          signal: controller.signal
        });
        const responsePayload = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(responsePayload.error || translate('error_submit_order', 'Dres nije poslan. Pokušajte ponovo.'));
        }
        if (!responsePayload.success || !responsePayload.draftOrder || !responsePayload.draftOrder.id) {
          throw new Error(translate('error_submit_order', 'Dres nije poslan. Pokušajte ponovo.'));
        }

        completedFingerprint = currentFingerprint;
        const successDetails = getSuccessDetails(responsePayload);
        setStatus(
          [translate('order_submitted', 'Dres je uspješno poslan osoblju.'), successDetails.reference, successDetails.total]
            .filter(Boolean)
            .join(' '),
          'success'
        );
        setButtons({ disabled: true, label: responsePayload.draftOrder?.name || translate('order_submitted', 'Poslano') });
        if (elements.resetDraftOrderButton) elements.resetDraftOrderButton.hidden = false;
        openSuccessModal(responsePayload);
        root.dispatchEvent(
          new CustomEvent('jersey-builder:draft-order-success', {
            bubbles: true,
            detail: responsePayload
          })
        );

        if (fingerprint(buildPayload()) !== currentFingerprint) {
          completedFingerprint = '';
          clearPendingSubmission();
          setButtons();
          if (elements.resetDraftOrderButton) elements.resetDraftOrderButton.hidden = true;
        }
      } catch (error) {
        const message = error && error.name === 'AbortError'
          ? translate('error_submit_timeout', 'Zahtjev je istekao. Pokušajte ponovo.')
          : error.message || translate('error_submit_order', 'Dres nije poslan. Pokušajte ponovo.');
        setStatus(message, 'error');
        setButtons();
        root.dispatchEvent(
          new CustomEvent('jersey-builder:draft-order-error', {
            bubbles: true,
            detail: { error }
          })
        );
      } finally {
        window.clearTimeout(timeout);
        isSubmitting = false;
        setSubmissionPending(root, false);
      }
    }

    function configurationChanged() {
      const currentFingerprint = fingerprint(buildPayload());
      if (completedFingerprint && currentFingerprint !== completedFingerprint) {
        completedFingerprint = '';
        clearPendingSubmission();
        setStatus('', '');
        if (elements.resetDraftOrderButton) elements.resetDraftOrderButton.hidden = true;
      }
      if (!isSubmitting && !completedFingerprint) setButtons();
    }

    function startAnother() {
      clearPendingSubmission();
      window.location.reload();
    }

    function productChanged() {
      completedFingerprint = '';
      setStatus('', '');
      if (elements.resetDraftOrderButton) elements.resetDraftOrderButton.hidden = true;
      if (!isSubmitting) setButtons();
    }

    return { submit, configurationChanged, productChanged, startAnother };
  }

  function bindControls(elements, state, renderer, syncCartForm, submitCart, draftOrderSubmitter) {
    function renderConfigurationChange() {
      renderer.updateRootState();
      renderer.renderImage();
      renderer.preloadNumberAssets({ immediate: true });
      renderer.renderPreview();
      renderer.renderPrice();
      renderer.renderButtons();
      renderer.renderStickyPreview();
      syncCartForm();
      draftOrderSubmitter.configurationChanged();
    }

    function handleGarnituraChange(value) {
      state.garnitura = value;
      renderer.renderGarnituraOptions(handleGarnituraChange);
      renderer.renderSizeAvailability();
      renderConfigurationChange();
    }

    function handleSizeChange(value) {
      state.size = value;
      renderer.renderSizeOptions(handleSizeChange);
      renderer.renderSizeAvailability();
      renderConfigurationChange();
    }

    function handleSponsorChange(value) {
      state.sponsor = value;
      renderer.updateRootState();
      renderer.renderImage();
      renderer.preloadSelectedSponsorImages({ immediate: true });
      renderer.renderPrice();
      renderer.renderStickyPreview();
      syncCartForm();
      draftOrderSubmitter.configurationChanged();
    }

    function handlePrintTypeChange(value) {
      state.printType = value;

      if (value !== 'player') {
        state.playerIndex = '';
        if (elements.playerSelect) elements.playerSelect.value = '';
      }
      if (value !== 'custom') {
        state.customName = '';
        state.customNumber = '';
        if (elements.customName) elements.customName.value = '';
        if (elements.customNumber) elements.customNumber.value = '';
      }

      renderer.renderPrintTypeOptions(handlePrintTypeChange);
      // Print selection can switch the preview from the front image to the back image.
      renderer.updateRootState();
      renderer.renderImage();
      renderer.preloadSelectedSponsorImages({ immediate: true });
      renderer.renderPreview();
      renderer.renderPrice();
      renderer.renderPrintVisibility();
      renderer.renderStickyPreview();
      syncCartForm();
      draftOrderSubmitter.configurationChanged();
    }

    function renderProduct() {
      renderer.renderGarnituraOptions(handleGarnituraChange);
      renderer.renderSizeOptions(handleSizeChange);
      renderer.renderSponsorOptions(handleSponsorChange);
      renderer.renderPrintTypeOptions(handlePrintTypeChange);
      renderer.renderPlayerOptions();

      if (elements.playerSelect) elements.playerSelect.value = state.playerIndex;
      if (elements.customName) elements.customName.value = state.customName;
      if (elements.customNumber) elements.customNumber.value = state.customNumber;

      renderer.renderAll(syncCartForm);
      draftOrderSubmitter.configurationChanged();
    }

    renderProduct();

    if (elements.playerSelect) {
      elements.playerSelect.addEventListener('change', (event) => {
        state.playerIndex = event.target.value;
        renderer.renderPreview();
        renderer.renderPrice();
        renderer.renderStickyPreview();
        syncCartForm();
        draftOrderSubmitter.configurationChanged();
      });
    }

    if (elements.customName) {
      elements.customName.addEventListener('input', (event) => {
        const clean = sanitizeName(event.target.value);
        event.target.value = clean;
        state.customName = clean;
        renderer.renderPreview();
        renderer.renderPrice();
        renderer.renderStickyPreview();
        syncCartForm();
        draftOrderSubmitter.configurationChanged();
      });
    }

    if (elements.customNumber) {
      elements.customNumber.addEventListener('input', (event) => {
        const clean = sanitizeNumber(event.target.value);
        event.target.value = clean;
        state.customNumber = clean;
        renderer.renderPreview();
        renderer.renderPrice();
        renderer.renderStickyPreview();
        syncCartForm();
        draftOrderSubmitter.configurationChanged();
      });
    }

    if (elements.addButton) elements.addButton.addEventListener('click', () => submitCart(elements.addButton));
    if (elements.stickyAddButton) elements.stickyAddButton.addEventListener('click', () => submitCart(elements.stickyAddButton));
    if (elements.draftOrderButton) elements.draftOrderButton.addEventListener('click', draftOrderSubmitter.submit);
    if (elements.stickyDraftOrderButton) elements.stickyDraftOrderButton.addEventListener('click', draftOrderSubmitter.submit);
    if (elements.resetDraftOrderButton) elements.resetDraftOrderButton.addEventListener('click', draftOrderSubmitter.startAnother);

    return { renderProduct };
  }

  function bindObservers(root, elements, renderer) {
    let stickyVisibilityFrame = 0;

    function scheduleStickyVisibilityUpdate() {
      if (stickyVisibilityFrame) return;
      stickyVisibilityFrame = window.requestAnimationFrame(() => {
        stickyVisibilityFrame = 0;
        renderer.updateStickyVisibility();
      });
    }

    if (elements.frame && window.ResizeObserver) {
      const resizeObserver = new ResizeObserver((entries) => {
        renderer.updateFrameWidth(entries[0].contentRect.width || elements.frame.clientWidth);
      });
      resizeObserver.observe(elements.frame);
    }

    if (elements.stickyPreview && elements.frame && window.IntersectionObserver) {
      const previewObserver = new IntersectionObserver(
        (entries) => renderer.setMainPreviewVisible(entries[0] ? entries[0].intersectionRatio > 0.28 : true),
        { threshold: [0, 0.28] }
      );
      previewObserver.observe(elements.frame);
    }

    if (window.IntersectionObserver) {
      const sectionObserver = new IntersectionObserver(renderer.updateStickyVisibility, { threshold: [0] });
      sectionObserver.observe(root);
    }

    window.addEventListener('scroll', scheduleStickyVisibilityUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyVisibilityUpdate);

    if (renderer.mobileMedia && typeof renderer.mobileMedia.addEventListener === 'function') {
      renderer.mobileMedia.addEventListener('change', scheduleStickyVisibilityUpdate);
    }
  }

  function updateProductPresentation(root, elements, model, options = {}) {
    root.dataset.activeProductKey = model.productKey;
    root.dataset.jerseyFont = model.fontKey;
    root.style.setProperty('--jersey-font-family', `"${model.fontFamily}"`);
    root.style.setProperty('--jersey-font-weight', String(model.fontWeight));

    if (elements.productTitle) {
      elements.productTitle.textContent = model.productTitle;
      markWeglotDynamicText(elements.productTitle, model.productTitle);
    }

    [elements.image, elements.stickyPreviewImage].forEach((image) => {
      if (!image) return;
      image.alt = model.productTitle;
      addWeglotDynamicAttribute(image, 'alt', model.productTitle);
    });

    elements.productSwitches.forEach((button) => {
      const isActive = button.dataset.jerseyProductSwitch === model.productKey;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (options.announce && elements.productStatus) {
      elements.productStatus.textContent = model.productTitle;
    }

    if (typeof window.preloadFkSarajevoJerseyFont === 'function') {
      window.preloadFkSarajevoJerseyFont(model.fontKey);
    }
  }

  function bindProductSwitcher(root, elements, productController, controls, renderer, draftOrderSubmitter) {
    function activate(button, options = {}) {
      if (!button || button.disabled || Number(root.dataset.jerseySubmissionCount || 0) > 0) return;
      if (!productController.activate(button.dataset.jerseyProductSwitch)) return;

      updateProductPresentation(root, elements, productController.model, { announce: options.announce });
      draftOrderSubmitter.productChanged();
      controls.renderProduct();
      renderer.preloadNumberAssets({ immediate: true });
      renderer.preloadSelectedSponsorImages({ immediate: true });

      root.dispatchEvent(
        new CustomEvent('jersey-builder:product-change', {
          bubbles: true,
          detail: {
            productId: productController.model.productId,
            productKey: productController.model.productKey
          }
        })
      );
    }

    elements.productSwitches.forEach((button, index) => {
      button.addEventListener('click', () => activate(button, { announce: true }));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = elements.productSwitches.length - 1;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + elements.productSwitches.length) % elements.productSwitches.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % elements.productSwitches.length;

        const nextButton = elements.productSwitches[nextIndex];
        activate(nextButton, { announce: true });
        nextButton?.focus();
      });
    });
  }

  function preloadInactiveProducts(productController) {
    function preload() {
      productController.models.forEach((model) => {
        if (model.productKey === productController.activeKey()) return;
        const initialVariant = model.variantIdMap[String(model.initialVariantId)] || model.variants.find((variant) => variant.available);
        const source = shopifyImageUrl(variantImage(initialVariant), JERSEY_PREVIEW_WIDTHS[0]);
        if (!source) return;

        const image = new Image();
        image.decoding = 'async';
        image.fetchPriority = 'low';
        image.src = source;
      });
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preload, { timeout: 2000 });
    } else {
      window.setTimeout(preload, 750);
    }
  }

  function init(root) {
    if (root.dataset.jerseyBuilderInitialized === 'true') return;

    const data = readBuilderData(root);
    if (!data) return;

    const productController = createProductController(data);
    if (!productController.hasProducts) return;

    root.dataset.jerseyBuilderInitialized = 'true';
    const model = productController.model;
    const state = productController.state;
    const elements = queryElements(root);
    updateProductPresentation(root, elements, model);
    const selectors = createSelectors(model, state);
    const renderer = createRenderer(root, elements, model, state, selectors);
    const kioskCacheWarmer = new KioskImageCacheWarmer(root, productController.models, elements.frame);
    const syncCartForm = createCartFormSync(elements, state, selectors);
    const draftOrderSubmitter = createDraftOrderSubmitter(root, elements, data, state, selectors);

    const controls = bindControls(
      elements,
      state,
      renderer,
      syncCartForm,
      createCartSubmitter(root, elements, state, selectors, syncCartForm),
      draftOrderSubmitter
    );
    bindProductSwitcher(root, elements, productController, controls, renderer, draftOrderSubmitter);
    bindObservers(root, elements, renderer);

    renderer.preloadNumberAssets({ afterPageLoad: true });
    renderer.preloadSelectedSponsorImages({ afterPageLoad: true });
    kioskCacheWarmer.start({ afterPageLoad: true });
    preloadInactiveProducts(productController);
    renderer.updateStickyBarVisibility();
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches(SELECTORS.root)) init(scope);
    scope.querySelectorAll?.(SELECTORS.root).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
